import { useEffect, useState } from "react";
import { isExcludedVariation } from "../Kameleoon";
import { useKameleoon } from "./useKameleoon";
const useAssignedVariationByExperimentId = ({ experimentId, enabled = true, }) => {
    const kameleoon = useKameleoon();
    const [assignedVariation, setAssignedVariation] = useState(enabled ? undefined : null);
    useEffect(() => {
        if (!(kameleoon && enabled)) {
            return;
        }
        const variation = kameleoon.assignedVariantByExperimentId({ experimentId });
        const isActiveVariation = variation && !isExcludedVariation(variation);
        setAssignedVariation(isActiveVariation ? variation : null);
    }, [enabled, experimentId, kameleoon]);
    return { assignedVariation };
};
export { useAssignedVariationByExperimentId };
